const terrainColors = {
    water: [35, 95, 150],
    plains: [105, 180, 75],
    forest: [50, 120, 75],
    hills: [150, 120, 75],
    mountain: [165, 165, 180],
    coast: [105, 170, 170],
    river: [90, 135, 180]
};

const terrainImages = {
    water: [
        "m 2.54,1.905 c 0.5204697,0.1101558 0.8035381,0.6565644 1.9049999,0 0.570648,-0.3356081 1.173401,-0.5037825 1.905,0",
        "m 7.3024999,1.905 c 0.5772661,0.2619364 1.161295,0.5607017 1.5875,0 0.5789956,-0.5685228 0.9153419,-0.2508215 1.2700001,0"
    ],
    plains: [
        "m 2.54,1.5875 v 0.635",
        "M 3.4925,2.2225 V 1.27",
        "M 4.4449999,2.2225 V 1.27",
        "M 5.3974999,2.2225 V 1.5875",
        "M 6.3499999,2.2225 V 1.27",
        "M 7.3024999,2.2225 V 1.5875",
        "M 8.2549999,2.2225 V 1.5875",
        "M 8.8899999,2.2225 C 8.8869921,1.8718327 8.89,1.5875 9.2075,1.27",
        "M 10.16,2.2225 V 1.5875"
    ],
    forest: [
        "M 3.81,2.2225 V 0.95249999",
        "M 3.4925,1.5875 3.81,0.95249999 4.1274999,1.5875",
        "M 5.0799999,2.2225 V 0.3175",
        "m 4.7624999,0.95249999 0.3175,-0.63499999 0.3175,0.63499999",
        "m 4.7624999,1.5875 0.3175,-0.3175 0.3175,0.3175",
        "M 6.3499999,2.2225 V 1.27",
        "m 6.0324999,1.5875 0.3175,-0.3175 0.3175,0.3175",
        "M 7.6199999,2.2225 V 0.95249999",
        "m 7.3024999,1.5875 0.3175,-0.63500001 0.3175,0.63500001",
        "M 8.8899999,2.2225 V 1.27",
        "m 8.5724999,1.905 0.3175,-0.635 0.3175,0.635"
    ],
    hills: [
        "m 1.27,2.2225 c 1.6730557,-0.6252721 3.4223419,-1.0450434 5.7149999,0",
        "M 5.0799999,1.5875 C 6.8376303,1.297317 8.418409,0.44243604 11.43,1.905"
    ],
    mountain: [
        "M 1.27,2.2225 1.5875,1.27 1.905,1.5875 2.54,0.3175 2.8575,0.63499999 3.175,1.27 3.4925,0.95249999 4.1274999,1.5875 l 0.635,0.3175 0.3175,-0.3175 0.3175,0.3175 0.9525,-0.635 h 0.3175 l 0.635,0.3175 0.3175,-0.3175 0.635,0.9525 0.3175,-0.635 0.635,0.3175 L 9.8425,1.5875 10.16,1.905 10.795,0.95249999 11.1125,1.27 11.43,1.905 v 0.3175"
    ],
    coast: [
        "m 2.54,0.9525 h 2.8575 l 0.635,1.27",
        "M 5.7149999,1.5875 C 6.6675,1.5875 7.6200001,1.905 8.5725,1.905 c 0.635,0 0.9525,-0.3175 1.5875,-0.3175 0.3175,0 0.922347,0.1402947 1.27,0.3175",
        "m 4.7624999,0.63499999 c 0,0.3175 0,0.3175 0,0.3175",
        "m 4.1274999,0.63499999 v 0.3175"
    ],
    river: [
        "m 2.54,1.905 c 1.0583333,-0.016727 2.1166666,-0.1146562 3.1749999,0",
        "m 4.4449999,1.27 c 0.9525,0.01846 1.905,0.072013 2.8575,0",
        "m 6.6675,1.905 c 0.8466667,0.1260188 1.6933333,0.00446 2.54,0",
        "M 8.2549999,1.27 C 8.8899999,1.2027364 9.525,1.2439391 10.16,1.27",
        "M 3.175,1.27 C 2.8900165,1.2333416 2.7353966,1.2618649 2.54,1.27"
    ]
};

const getTerrainColor = (index, saturation, lightness) => {
    const colors = terrainColors[index];
    const gray = Math.round((colors[0] + colors[1] + colors[2])/3);
    const grayedColors = [(colors[0] - gray) * saturation + gray, (colors[1] - gray) * saturation + gray, (colors[2] - gray) * saturation + gray];
    const dimmedColors = [grayedColors[0] * lightness, grayedColors[1] * lightness, grayedColors[2] * lightness];
    return `rgb(${Math.round(dimmedColors[0])}, ${Math.round(dimmedColors[1])}, ${Math.round(dimmedColors[2])})`;
}

const precalculatedColors = {
    water: {
        terrainClaimedBackgroundFillStyle: getTerrainColor('water', 1.0, 1.0),
        terrainUnclaimedBackgroundFillStyle: getTerrainColor('water', 0.8, 0.5),
        terrainUnclaimedInnerFillStyle: getTerrainColor('water', 0.7, 0.3),
        terrainClaimedBorderStrokeStyle: getTerrainColor('water', 0.7, 0.3),
        terrainUnclaimedBorderStrokeStyle: getTerrainColor('water', 0.8, 0.4)
    },
    plains: {
        terrainClaimedBackgroundFillStyle: getTerrainColor('plains', 1.0, 1.0),
        terrainUnclaimedBackgroundFillStyle: getTerrainColor('plains', 0.8, 0.5),
        terrainUnclaimedInnerFillStyle: getTerrainColor('plains', 0.7, 0.3),
        terrainClaimedBorderStrokeStyle: getTerrainColor('plains', 0.7, 0.3),
        terrainUnclaimedBorderStrokeStyle: getTerrainColor('plains', 0.8, 0.4)
    },
    forest: {
        terrainClaimedBackgroundFillStyle: getTerrainColor('forest', 1.0, 1.0),
        terrainUnclaimedBackgroundFillStyle: getTerrainColor('forest', 0.8, 0.5),
        terrainUnclaimedInnerFillStyle: getTerrainColor('forest', 0.7, 0.3),
        terrainClaimedBorderStrokeStyle: getTerrainColor('forest', 0.7, 0.3),
        terrainUnclaimedBorderStrokeStyle: getTerrainColor('forest', 0.8, 0.4)
    },
    hills: {
        terrainClaimedBackgroundFillStyle: getTerrainColor('hills', 1.0, 1.0),
        terrainUnclaimedBackgroundFillStyle: getTerrainColor('hills', 0.8, 0.5),
        terrainUnclaimedInnerFillStyle: getTerrainColor('hills', 0.7, 0.3),
        terrainClaimedBorderStrokeStyle: getTerrainColor('hills', 0.7, 0.3),
        terrainUnclaimedBorderStrokeStyle: getTerrainColor('hills', 0.8, 0.4)
    },
    mountain: {
        terrainClaimedBackgroundFillStyle: getTerrainColor('mountain', 1.0, 1.0),
        terrainUnclaimedBackgroundFillStyle: getTerrainColor('mountain', 0.8, 0.5),
        terrainUnclaimedInnerFillStyle: getTerrainColor('mountain', 0.7, 0.3),
        terrainClaimedBorderStrokeStyle: getTerrainColor('mountain', 0.7, 0.3),
        terrainUnclaimedBorderStrokeStyle: getTerrainColor('mountain', 0.8, 0.4)
    },
    coast: {
        terrainClaimedBackgroundFillStyle: getTerrainColor('coast', 1.0, 1.0),
        terrainUnclaimedBackgroundFillStyle: getTerrainColor('coast', 0.8, 0.5),
        terrainUnclaimedInnerFillStyle: getTerrainColor('coast', 0.7, 0.3),
        terrainClaimedBorderStrokeStyle: getTerrainColor('coast', 0.7, 0.3),
        terrainUnclaimedBorderStrokeStyle: getTerrainColor('coast', 0.8, 0.4)
    },
    river: {
        terrainClaimedBackgroundFillStyle: getTerrainColor('river', 1.0, 1.0),
        terrainUnclaimedBackgroundFillStyle: getTerrainColor('river', 0.8, 0.5),
        terrainUnclaimedInnerFillStyle: getTerrainColor('river', 0.7, 0.3),
        terrainClaimedBorderStrokeStyle: getTerrainColor('river', 0.7, 0.3),
        terrainUnclaimedBorderStrokeStyle: getTerrainColor('river', 0.8, 0.4)
    }
};

const drawTerrain = (ctx, polygon, scaling, terrain, isClaimed, isFocused, canBeClaimed, interactable) => {
    const terrainScaling = isClaimed ? 1.0 : scaling;
    
    if (isClaimed) {
        ctx.fillStyle = precalculatedColors[terrain].terrainClaimedBackgroundFillStyle;
    } else {
        ctx.fillStyle = precalculatedColors[terrain].terrainUnclaimedBackgroundFillStyle;
    }
    
    ctx.beginPath();
    ctx.moveTo(polygon[0][0]*terrainScaling, polygon[0][1]*terrainScaling);
    for (let i = 1; i < polygon.length; i++) {
        ctx.lineTo(polygon[i][0]*terrainScaling, polygon[i][1]*terrainScaling);
    }
    ctx.closePath();
    ctx.fill();
    ctx.strokeStyle = isFocused ? (interactable ? "#ff0" : (isClaimed ? "#ccc" : "#c66")) : (canBeClaimed ? "#666" : "#222");
    ctx.stroke();
    if (!isClaimed) {
        const innerScaling = scaling * 0.9;
        ctx.fillStyle = precalculatedColors[terrain].terrainUnclaimedInnerFillStyle;
        ctx.beginPath();
        ctx.moveTo(polygon[0][0]*innerScaling, polygon[0][1]*innerScaling);
        for (let i = 1; i < polygon.length; i++) {
            ctx.lineTo(polygon[i][0]*innerScaling, polygon[i][1]*innerScaling);
        }
        ctx.closePath();
        ctx.fill();
    }
    
    ctx.save();
    if (isClaimed) {
        ctx.strokeStyle = precalculatedColors[terrain].terrainClaimedBorderStrokeStyle;
    } else if (canBeClaimed) {
        ctx.strokeStyle = "rgb(220, 220, 180)";
    } else {
        ctx.strokeStyle = precalculatedColors[terrain].terrainUnclaimedBorderStrokeStyle;
    }
    ctx.scale(10, 10);
    ctx.translate(-6.5, isClaimed ? 5 : -2);
    ctx.lineWidth=0.25;
    ctx.stroke(new Path2D(terrainImages[terrain].join(' M 0,0 ')));
    ctx.restore();
};

const drawAdvancementOrResource = (ctx, polygon, resource, advancement, canBeAdvanced, isClaimed, hasAdvancements) => {
    if (advancement !== undefined) {
        ctx.strokeStyle = canBeAdvanced ? "rgb(220, 220, 180)" : "rgb(0, 0, 0)";
        if (advancement.image) {
            ctx.save();
            ctx.scale(8, 8);
            ctx.translate(-6.5, -6);
            ctx.lineWidth=0.5;
            ctx.stroke(new Path2D(advancement.image.join(' M 0,0 ')));
            ctx.restore();
        }
    } else if (resource !== undefined && isClaimed) {
        if (resource.image) {
            ctx.save();
            ctx.strokeStyle = canBeAdvanced ? "rgb(30, 30, 30)" : "rgb(200, 200, 200)";
            ctx.scale(12, 12);
            ctx.translate(-6.5, -6.4);
            ctx.lineWidth=0.2;
            ctx.fillStyle = canBeAdvanced ? "rgb(220, 220, 180)" : "rgb(30, 30, 30)";
            ctx.fillRect(3.5, 3.5, 5.7, 5.7);
            ctx.stroke(new Path2D(resource.image.join(' M 0,0 ')));
            ctx.restore();
        }
    }

    if (isClaimed && (advancement !== undefined || resource !== undefined)) {
        const level = advancement !== undefined ? advancement.level : 2;
        ctx.fillStyle = canBeAdvanced || hasAdvancements ? "rgb(220, 220, 180)" : "rgba(0, 0, 0, 0.5)";
        const dotStart = -(level - 1) * 8;
        for (let l = 0; l < level; l++) {
            ctx.beginPath();
            ctx.arc(dotStart + l*16, -60, 3, 0, 2 * Math.PI, false);
            ctx.fill();
        }
    }
};

const makeRenderer = (grid, canvas, info) => {
    let focusUV = [-1000, -1000];
    const ctx = canvas.getContext('2d');
    let baseScaling = [1.0, 1.0];
    let baseTranslation = [1.0, 1.0];

    const resize = () => {
        const windowWidth = Math.floor(canvas.offsetWidth);
        const windowHeight = Math.floor(canvas.offsetHeight);
        const windowAspect = windowWidth / windowHeight;
        const logicalWidth = grid.calcActualWidth(grid.getWidth());
        const logicalHeight = grid.calcActualHeight(grid.getHeight());
        const logicalAspect = logicalWidth / logicalHeight;

        canvas.setAttribute('height', windowHeight);
        canvas.setAttribute('width', windowWidth);

        if (windowAspect > logicalAspect) {
            baseScaling = [windowHeight/logicalHeight, windowHeight/logicalHeight];
            baseTranslation = [(logicalHeight * windowAspect - logicalWidth) / 2, 0];
        } else {
            baseScaling = [windowWidth/logicalWidth, windowWidth/logicalWidth];
            baseTranslation = [0, (logicalWidth / windowAspect - logicalHeight) / 2];
        }
    };

    resize();
    window.addEventListener('resize', resize);
    
    return {
        render: () => {
            ctx.fillColor = 'black';
            ctx.fillRect(0, 0, canvas.width, canvas.height);
            ctx.save();
            ctx.scale(...baseScaling);
            ctx.translate(...baseTranslation);
            const polygon = grid.getPolygon();
            const scaling = 0.98;
            grid.traverseAll((u, v) => {
                ctx.save();
                const [x, y] = grid.getMidpoint(u, v);
                ctx.translate(x, y);
                let canBeAdvanced = false;
                let canBeClaimed = false;
                let isClaimed = false;
                let hasAdvancements = false;
                info.judgeCell(u, v, {
                    advancementPossible: () => canBeAdvanced = isClaimed = true,
                    claimedButAdvancementNotPossible: (available) => { isClaimed = true; hasAdvancements = available.length > 0; },
                    claimPossible: () => canBeClaimed = true
                });
                drawTerrain(ctx, polygon, scaling, info.getTerrain(u, v), isClaimed, focusUV[0] === u && focusUV[1] === v, canBeClaimed, false);
                drawAdvancementOrResource(ctx, polygon, info.getUniqueResource(u, v), info.getAdvancement(u, v), canBeAdvanced, isClaimed, hasAdvancements);
                ctx.restore();
            });

            if (!(focusUV[0] === -1000 && focusUV[1] === -1000)) {
                const [u, v] = focusUV;
                ctx.save();
                const [x, y] = grid.getMidpoint(u, v);
                ctx.translate(x, y);
                let interactable = false;
                let canBeAdvanced = false;
                let canBeClaimed = false;
                let hasAdvancements = false;
                info.judgeCell(u, v, {
                    advancementPossible: () => interactable = canBeAdvanced = true,
                    claimedButAdvancementNotPossible: (available) => { interactable = true; hasAdvancements = available.length > 0; },
                    claimPossible: () => interactable = canBeClaimed = true
                });
                if (interactable) {
                    ctx.scale(1.1, 1.1);
                }
                drawTerrain(ctx, polygon, scaling, info.getTerrain(u, v), info.isClaimed(u, v), true, canBeClaimed, interactable);
                drawAdvancementOrResource(ctx, polygon, info.getUniqueResource(u, v), info.getAdvancement(u, v), canBeAdvanced, info.isClaimed(u, v), hasAdvancements);
                ctx.restore();
            }
            ctx.restore();
        },

        getTransform: () => {
            ctx.save();
            ctx.scale(...baseScaling);
            ctx.translate(...baseTranslation);
            let transform = ctx.getTransform();
            ctx.restore();
            return transform;
        },

        setFocus: (u, v, force) => {
            if (u !== focusUV[0] || v !== focusUV[1] || force) {
                canvas.style.cursor = 'default';
                info.judgeCell(u, v, {
                    advancementPossible: () => canvas.style.cursor = 'pointer',
                    claimedButAdvancementNotPossible: () => canvas.style.cursor = 'pointer',
                    claimPossible: () => canvas.style.cursor = 'pointer'
                });
            }
            focusUV = [u, v];
        },
    };
}

export default makeRenderer;